export const routePaths = {
  home: '/',
  auth: '/auth',
  clientsList: '/clients',
  client: '/clients/:clientId',

  orders: '/orders',
  order: '/orders/:orderId',
  cargos: '/cargos',
  cargo: '/cargos/:cargoId',
  trips: '/trips',
  trip: '/trips/:tripId',
  invoices: '/invoices',
  invoice: '/invoices/:invoiceId',
  expenses: '/expenses',
  expense: '/expenses/:expenseId',

  warehouses: '/warehouses',
  transports: '/transports',
  users: '/users',
  costsPerKm: '/costs-per-km',

  transportPerformance: '/statistics/transport-performance',
  transportLoad: '/statistics/transport-load',
  distributionEfficiency: '/statistics/distribution-efficiency',
  statisticProfit: '/statistics/profit',
  whPerformance: '/statistics/wh-performance',
  overdue: '/statistics/overdue',
  futurePayments: '/statistics/future-payments',

  whTasks: '/wh-tasks',
  whTask: '/wh-tasks/:whTaskId',

  whInfo: '/wh-info',
} as const;
